import { services } from '@/mocks/services';

export default function ServiceSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            核心服务
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            一站式品牌传播解决方案
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            从策略到执行，从创意到数据，果冻传媒提供覆盖品牌传播全链路的专业服务
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${service.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-check-line text-accent-500 text-sm"></i>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}